/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

import React from 'react';
import { FormControl, InputGroup, Button } from 'react-bootstrap';
import QuestionMark from '../../../../shared/QuestionMark';
const Upload = (props) => {
    const {
        controlLabel,
        isUploadLoading,
        changePopup,
        onChangeAction,
        inputFileValue,
        errorMsg,
        isHaveDelteBtn,
        openDeleteDialog,
        i18n,
        questionIndicator,
        isHaveLine,
        isStatus
    } = props;

    const errorTips = (index) => {        
        switch (index) {
            case 1:
                // 上传格式错误
                return i18n.fileUploadInfo.errorTips;
            case 2:
                // 上传异常
                return i18n.fileUploadInfo.uploadFail;
            case 3:
                // 上传的文件大于5M
                return i18n.fileUploadInfo.errorMsgMax;
            case 4:
                // please upload
                return i18n.fileUploadInfo.noUpload;
            case 5:
                // file name length > 100 letters
                return i18n.fileUploadInfo.errorMsgLetters;
            default:
                // 上传异常
                return i18n.fileUploadInfo.uploadFail;
        }
    };
    // error Style
    const isErrorStyle = (errorMsg > 0) ? "error-style" : "";
    // 添加QuestionMark问号提示
    const isHlepArr = ["AddProofFile", "AddProofOffFile"];
    const isHlep = isHlepArr.indexOf(questionIndicator) > -1;

    return (
        <div data-key={ questionIndicator } className={`file-upload-field clearfix ${isHaveLine ? "b-line" : ""}`}>
            <InputGroup>
                <controlLabel>
                    <span className="control-label clearfix">{controlLabel}
                    {   isHlep &&
                        <QuestionMark questionTitle={ controlLabel }>
                            <hints dataKey={ questionIndicator }>{ i18n.fileUploadInfo.questionMark.proofOfAddress }</hints>
                        </QuestionMark>
                    }
                    </span>
                </controlLabel>

                <div className="control-box clearfix">                    
                    <FormControl
                        style={{visibility: isUploadLoading ? 'hidden' : ''}}
                        type="file"
                        name={questionIndicator}
                        className="input-upload-file"
                        onChange={onChangeAction}
                        value={inputFileValue}
                        title={isStatus === 0 ? i18n.fileUploadInfo.pleaseUpload : i18n.fileUploadInfo.uploaded}
                    />

                    <span className={`success-text ${isErrorStyle}`}>
                        { (isStatus === 2 || isStatus === 1) && 
                        <span>
                            {/* 已上传 */}
                            <b>{i18n.fileUploadInfo.uploaded}</b>
                            <i className={'icon icon-circle-confirmation-solid'}></i>
                        </span>
                        }
                        {
                            isStatus === 0 &&
                        <span>
                            {/* 请上传文件 */}
                            <b>{i18n.fileUploadInfo.pleaseUpload}</b>
                        </span>
                        }
                    </span>

                    <div className={'upload-visual-container'}>
                        <FormControl
                            style={{visibility: isUploadLoading ? 'hidden' : ''}}
                            type="file"
                            name={questionIndicator}
                            className="input-upload-btn"
                            onChange={onChangeAction}
                            value={inputFileValue}
                            title={i18n.fileUploadInfo.upload}
                        />
                        { isUploadLoading ?
                            (
                                <span className="full-screen-loading" style={ {display: true ? '' : 'none'} }>
                                    <i className="icon " aria-hidden="true">{}</i>
                                </span>
                            ) :
                            (
                            <Button className="btn-file-upload"
                                disabled={isUploadLoading}
                                bsStyle="info"
                                data-key="i18n.fileUploadInfo.upload"
                                aria-hidden="true"
                                tabIndex={-1}
                                >
                                {i18n.fileUploadInfo.upload}
                            </Button>
                            )
                        }

                    </div>


                    <div className="business-show" >
                        {/* tips: 审核通过( 查看文件) */}
                        { 
                            isStatus === 2 &&
                            <Button title={i18n.fileUploadInfo.ViewFile} className="success-view-txts" onClick={changePopup}>
                                {i18n.fileUploadInfo.ViewFile}
                            </Button>
                        }
                        {/* tips: 正在审核中... */}
                        {
                            !errorMsg && isStatus === 1 &&
                            <div className="upload-file-errormsg auditmsg">
                                <i className="icon icon-circle-error-solid"></i>
                                {i18n.fileUploadInfo.auditFileTips}
                            </div>
                        }
                        {/* tips: 审核不通过... */}
                        {
                            !errorMsg && isStatus === 3 &&
                            <div className="upload-file-errormsg auditmsg">
                                <i className="icon icon-circle-error-solid"></i>
                                {i18n.fileUploadInfo.noPassTips}
                            </div>
                        }
                        {/* tips: 上传错误 */}
                        {   errorMsg &&
                            <div className="upload-file-errormsg">
                                <i className="icon icon-circle-delete"></i>
                                { errorTips(errorMsg) }
                            </div>
                        }
                    </div>

                    {
                        isHaveDelteBtn &&
                        <Button title={i18n.fileUploadInfo.remove} className="file-upload-delete-btn" onClick={openDeleteDialog} data-key="i18n.fileUploadInfo.remove">
                            <i aria-hidden="true" className="icon icon-delete"></i>
                            <span>{i18n.fileUploadInfo.remove}</span>
                        </Button>
                    }
                </div>
                    
            </InputGroup>

        </div>
    )
};

export default Upload;


// WEBPACK FOOTER //
// ./src/views/FileUploadInfo/components/child/UploadCom.js